import { apartmentReceiptModelGet } from '../../models/apartments/apartmentReceipt';
import { receiptModelGet } from '../../models/receipts/receipt';

export const receiptViewModelModelGet = ({
    buildingId = '',
    apartmentId = '',
    receiptId = '',
    expenseTemplateId = '',
    receiptGenerateds = 0,
    userId = '',
}) => {
    return {
        ...apartmentReceiptModelGet({
            buildingId: buildingId,
            apartmentId: apartmentId,
            receiptId: receiptId,
            userId: userId,
        }),
        receipt: receiptModelGet({
            buildingId: buildingId,
            expenseTemplateId: expenseTemplateId,
            receiptGenerateds: receiptGenerateds,
            userId: userId,
        }),
    }
};